import styled from 'styled-components';
import { donedealBreakpoints } from 'styled-system';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, 48px);
  grid-row-gap: ${({ theme }) => theme.spacing.M16};
`;

export const MinMaxSelectWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: ${({ theme }) => theme.spacing.M16};

  & > * {
    flex: 1;
  }

  ${donedealBreakpoints.media.medium} {
    grid-column: span 2;
  }
`;
